var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 30,
    rx: 8,
    fill: "#f1613f",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3340_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21.125V19.875C20 19.212 19.7366 18.5761 19.2678 18.1072C18.7989 17.6384 18.163 17.375 17.5 17.375H13.125C12.462 17.375 11.8261 17.6384 11.3572 18.1072C10.8884 18.5761 10.625 19.212 10.625 19.875V21.125",
    stroke: "#f1613f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 14.875C16.6932 14.875 17.8125 13.7557 17.8125 12.375C17.8125 10.9943 16.6932 9.875 15.3125 9.875C13.9318 9.875 12.8125 10.9943 12.8125 12.375C12.8125 13.7557 13.9318 14.875 15.3125 14.875Z",
    stroke: "#f1613f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 14.875L21.875 16.125L24.375 13.625",
    stroke: "#f1613f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3340_4027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.33cc76bb8b3cb86dbb446be1e29cd321.svg";
export { ForwardRef as ReactComponent };